<div (click)="routingService.open('/main/water-points')"
     class="rounded-2 border-3 border-bottom background-pure-white p-3 pointer pointer-hover height-100px">
    @if (loading()) {
        <lib-loading-placeholder [show]="loading()"/>
    } @else {
        <div>
            <div class=" d-flex justify-content-between">
                <div class=" fs-main fw-bold mb-3">Water points</div>
                <div class=" mt-auto mb-auto">
                    <i class="color-primary-blue fa-solid fa-chevron-right fa-lg"></i>
                </div>
            </div>
            <div class="row">
                @if (unknown() > 0) {
                    <div class="col col-auto">
                        <app-water-point-svg
                            [height]="'30px'"
                            [innerColor]="'#FEFEFE'"
                            [outerColor]="'#424242'"
                            [width]="'30px'"
                            class="img-fluid img-max m-auto"/>
                        <span class="p-2">{{ unknown() }}</span>
                    </div>
                }
                @if (nominal() > 0) {
                    <div class="col col-auto">
                        <app-water-point-svg
                            [height]="'30px'"
                            [width]="'30px'"
                            class="img-fluid img-max m-auto"/>
                        <span class="p-2">{{ nominal() }}</span>
                    </div>
                }
                @if (warning() > 0) {
                    <div class="col col-auto">
                        <app-water-point-svg
                            [height]="'30px'"
                            [outerColor]="'#FFA60C'"
                            [width]="'30px'"
                            class="img-fluid img-max m-auto"/>
                        <span class="p-2">{{ warning() }}</span>
                    </div>
                }
                @if (alert() > 0) {
                    <div class="col col-auto">
                        <app-water-point-svg
                            [height]="'30px'"
                            [outerColor]="'#FF5B5B'"
                            [width]="'30px'"
                            class="img-fluid img-max m-auto"/>
                        <span class="p-2">{{ alert() }}</span>
                    </div>
                }
                @if (unassigned() > 0) {
                    <div class="col col-auto">
                        <app-water-point-svg
                            [height]="'30px'"
                            [innerColor]="'#FEFEFE'"
                            [outerColor]="'#DFDFDF'"
                            [width]="'30px'"
                            class="img-fluid img-max m-auto"/>
                        <span class="p-2">{{ unassigned() }}</span>
                    </div>
                }
            </div>
        </div>
    }
</div>
